import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowFirstSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2h1v8H2V2Zm8 .707L6.707 6 10 9.293 9.293 10l-4-4 4-4 .707.707Z"
    />
  </svg>
);
export default IconArrowFirstSizeXs;
